import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15fea94c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sizing" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container-close hidden\" data-v-15fea94c><div class=\"checkbox\" data-v-15fea94c><div class=\"to-bottom-right\" data-v-15fea94c></div><div class=\"to-bottom-left\" data-v-15fea94c></div></div><p data-v-15fea94c>CLOSE</p></div><p class=\"title\" data-v-15fea94c>HIRAIDAI TOUR 2022</p>", 2)
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "checkbox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "to-bottom-right" }),
  /*#__PURE__*/_createElementVNode("div", { class: "to-bottom-left" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "CLOSE", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "container-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ])
  ]))
}